//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    commonPageDetailLoad,loadRelationByUserName
} from "@/assets/api/dataBase.js";
import {
    utils
} from "@/assets/utils/utils.js";
import dbmap from "@/assets/dbs/hashmap.js"
import provinceBankJson from '@/assets/api/bank.json'
import vPinyin from '@/assets/utils/vue-py.js';

export default {
    data() {
        return {
            that: this,
            lastNameText: '姓名不能为空！',
            isUserName: false,
            isfullNameEng: false,
            sendInfo:{
                loanOrderCode: this.$route.query.loanOrderCode,
                fullNameEng: '', //姓名（拼音）
                userName:'', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName:'', // 名
            },
            provinceBankJson: [],
            bankCode: '',
            cardUserName: '',
            productCode: '',
            isAllRrquridSuccess: false,
            lastNEng: "",
            firstNEng: "",
        }
    },
    created() {
        this.provinceBankJson = provinceBankJson
    },
    mounted() {
        this.init()
    },
    filters: {
        nullFilter(val) {
            return val ? val : '--'
        },
        bankCodeFilter(val, that) {
            if (val) {
                let name = ''
                that.provinceBankJson.map((item, index) => {
                    if (val == item.bankCode) {
                        name = item.bankName
                    }
                });
                return name
            } else {
                return '--'
            }

        },
        productCodeFilter(val) {
            if (val == '6000') {
                return '个人经营性贷款'
            }
        }
    },
    methods: {
        init() {
            commonPageDetailLoad({
                loanOrderCode: this.$route.query.loanOrderCode
            }).then(result => {
                if (result.responseCode == '000000') {
                    let resData = result.responseData
                    this.bankCode = resData.loanInfo.bankCode
                    this.cardUserName = resData.loanUserInfo.cardUserName
                    this.productCode = resData.loanInfo.productCode
                    dbmap.set('productCode',this.productCode)
                    dbmap.set('bankCode',this.bankCode)
                }
            });
        },
        //姓名校验
        verNamePY(){
            this.isfullNameEng = true;
            if(!this.sendInfo.firstNameEng){
                this.isAllSuccess()
                return 
            }
            this.isfullNameEng = false;
            this.isAllSuccess()
        },
        verlastNamePY(){
            this.isfullNameEng = true;
            if(!this.sendInfo.lastNameEng){
                this.isAllSuccess()
                return 
            }
            this.isfullNameEng = false;
            this.isAllSuccess()
        },
        verlastName(){
            let reg = /^[\u4e00-\u9fa5]+$/
            if(this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)){
                this.lastNameText = '请输入中文！'
                this.isUserName = true;
            }else{
                this.isUserName = true;
                if(!this.sendInfo.lastName){
                    this.isAllSuccess()
                    this.verlastNamePY()
                    return 
                }
                let PinYin = vPinyin.chineseToPinYin(this.sendInfo.lastName);
                if( this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng){
                    this.sendInfo.lastNameEng = PinYin
                }
                if(reg.test(this.sendInfo.lastName) && reg.test(this.sendInfo.firstName)){
                    this.isUserName = false;
                }
                this.isAllSuccess()
                this.verlastNamePY()
                this.lastNEng = PinYin
            }
        },
        verName(){
            let reg = /^[\u4e00-\u9fa5]+$/
            if(this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)){
                this.lastNameText = '姓名请输入中文！'
                this.isUserName = true;
            }else{
                this.isUserName = true;
                if(!this.sendInfo.firstName){
                    this.isAllSuccess()
                    this.verNamePY()
                    return;
                }
                let PinYin = vPinyin.chineseToPinYin(this.sendInfo.firstName);
                if( this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng){
                    this.sendInfo.firstNameEng = PinYin
                }
                if(reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.firstName)){
                    this.isUserName = false;
                }
                this.isAllSuccess()
                this.verNamePY()
                this.firstNEng = PinYin
            }
        },
        isAllSuccess(){
            if( !this.isUserName && !this.isfullNameEng ){
                this.isAllRrquridSuccess = false
                return false
            }else{
                this.isAllRrquridSuccess = true
                return true
            }
        },
        //开始申请
        apply() {
            this.isAllRrquridSuccess = false
            this.verlastName()
            this.verName()
            this.verlastNamePY()
            this.verNamePY()
            let statusInfo = this.isAllSuccess()
            if(!statusInfo){
                this.next()
            }else{
                window.scrollTo(0, 0);
            }
        },
        next(){
            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName
            // 拼音加空格
            let capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            let ret = "";
            for (var i = 0; i < capital.length; i++) {
                let c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }
            this.sendInfo.fullNameEng = ret
            dbmap.set('loanOrderCode',this.$route.query.loanOrderCode)
            dbmap.set('sendInfo',this.sendInfo)
            
            loadRelationByUserName(this.sendInfo).then(result => {
                if(result.responseCode === "000000"){
                    let fbCode = result.responseData.fbCode
                    let messageInfo = utils.routerJump.returnUrl(fbCode);
                    let url = messageInfo.url
                    this.$router.push({
                        path:url,
                    })
                }
            })
        }
    }
};



// WEBPACK FOOTER //
// ./src/view/certified.vue